module.exports = __webpack_public_path__ + "img/shutterstock_135948689-800x356.4ad59450.jpg";